<template>  
  <div class="reduced-kidney-function">
    <div class="section-image">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="text-center section-name">Nedsatt njurfunktion</h1>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <b-form-input
              v-model="search"
              type="text"
              placeholder="Sök läkemedel" class="drug-search" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="view-container">
      <b-row>
        <b-col>
          <div v-if="user.isAdmin">
            <hr>
            <div class="text-center">
              <mu-raised-button class="demo-raised-button" label="Lägg till läkemedel" icon="add" primary @click="showCreateDialog"/>
            </div>
            <hr>
          </div>
          <ul v-if="filteredList.length > 0" class="drug-list">
            <li v-for="drug in filteredList" v-bind:key="drug.id">
              <b-row>
                <b-col cols="1" class="text-right">
                  <i class="fa fa-2x fa-angle-right"></i>
                </b-col>
                <b-col cols="10">
                  <router-link :to="'/nedsattnjurfunktion/' + drug.id">
                    <h4 :class="!drug.isPublished ? 'text-muted' : ''">
                      {{ drug.name }}  <mu-icon v-if="!drug.isPublished" value="visibility_off" color="#7e57c2"/>
                    </h4>
                    <span :class="!drug.isPublished ? 'text-muted' : ''">({{ drug.substance }})</span>
                  </router-link>
                </b-col>
              </b-row>
            </li>
          </ul>
          <p v-else-if="search" class="text-center">Inga matchande resultat</p>
        </b-col>
      </b-row>
    </b-container>
    <mu-dialog :open="showDialog" title="Lägg till läkemedel">
      <create-reduced-kidney-function-drug @close="closeDialog"></create-reduced-kidney-function-drug>
    </mu-dialog>
  </div>
</template>

<script>
import { getAll } from '../store/actions'
import CreateReducedKidneyFunctionDrug from '../components/CreateReducedKidneyFunctionDrug'
import { sortBy, filter, includes, toLower } from 'lodash'
import { clickTracker } from '@/services/helpers'

export default {
  name: 'ReducedKidneyFunction',
  components: { CreateReducedKidneyFunctionDrug },
  mounted () {
    getAll(this.$store)
    clickTracker('keyReducedKidneyFunctionList')
  },
  data () {
    return {
      search: '',
      showDialog: false
    }
  },
  methods: {
    showCreateDialog () {
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
    }
  },
  computed: {
    filteredList () {
      const filterString = toLower(this.search)
      const list = filterString
        ? filter(this.drugList, item => includes(toLower(item.name), filterString) || includes(toLower(item.substance), filterString))
        : this.drugList
      return sortBy(list, item => toLower(item.name))
    },
    drugList () {
      return this.$store.state.reducedKidneyFunctionDrugs
    },
    user () {
      return this.$store.state.user
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.demo-float-button {
  margin-right: 12px;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  padding-left: 10px;
}

ul li {
  list-style: none;
}

.drug-search {
  margin: 20px 0;
  padding: 10px;
}

.drug-list {
  h4 {
    margin-top: 1rem;
    margin-bottom: 0;
  }
  i.fa {
    color: $orange;
    margin-top: 20px;
  }
}

.section-name {
  color: $white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888;
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 170px;
  width: 100%;
  background-image: url("../assets/reduced-kidney-background.png");
  background-position-y: bottom;
  background-size: cover;
}

.view-container {
  padding-top: 0;
}
</style>
